var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNew = function SvgNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "New offer"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2838"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2741"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6074",
    d: "m41.17 2.471 9.624 26a1.258 1.258 0 0 0 .732.737l26 9.616a1.252 1.252 0 0 1 0 2.348l-26 9.616a1.269 1.269 0 0 0-.732.737l-9.624 26a1.25 1.25 0 0 1-2.344 0l-9.62-26a1.243 1.243 0 0 0-.737-.737l-26-9.616a1.253 1.253 0 0 1 0-2.348l26-9.616a1.232 1.232 0 0 0 .737-.737l9.62-26a1.25 1.25 0 0 1 2.344 0",
    fill: "#ffcf33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6075",
    d: "m13.283 3.236 2.706 7.317a.36.36 0 0 0 .208.208l7.317 2.706a.353.353 0 0 1 0 .663l-7.317 2.706a.36.36 0 0 0-.208.208l-2.706 7.317a.352.352 0 0 1-.659 0l-2.706-7.318a.36.36 0 0 0-.208-.208l-7.32-2.706a.355.355 0 0 1 0-.663l7.321-2.706a.36.36 0 0 0 .208-.208l2.706-7.317a.352.352 0 0 1 .659 0",
    fill: "#495867"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6076",
    d: "m64.833 9.433 1.742 4.712a.242.242 0 0 0 .134.134l4.712 1.742a.224.224 0 0 1 0 .423l-4.712 1.746a.22.22 0 0 0-.134.134l-1.742 4.708a.224.224 0 0 1-.423 0l-1.746-4.708a.2.2 0 0 0-.134-.134l-4.708-1.746a.224.224 0 0 1 0-.423l4.708-1.742a.22.22 0 0 0 .134-.134l1.746-4.712a.226.226 0 0 1 .423 0",
    fill: "#ffcf33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6077",
    d: "m13.861 58.791 1.738 4.713a.242.242 0 0 0 .134.134l4.712 1.742a.224.224 0 0 1 0 .423l-4.708 1.746a.22.22 0 0 0-.134.134l-1.742 4.708a.224.224 0 0 1-.423 0l-1.746-4.708a.2.2 0 0 0-.134-.134L6.85 65.803a.224.224 0 0 1 0-.423l4.708-1.742a.22.22 0 0 0 .134-.134l1.746-4.712a.226.226 0 0 1 .423 0",
    fill: "#ffcf33"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6078",
    d: "m67.881 56.989 2.706 7.317a.36.36 0 0 0 .208.208l7.317 2.706a.353.353 0 0 1 0 .663l-7.317 2.706a.36.36 0 0 0-.208.208l-2.706 7.317a.352.352 0 0 1-.659 0l-2.706-7.318a.36.36 0 0 0-.208-.208l-7.321-2.706a.355.355 0 0 1 0-.663l7.321-2.706a.36.36 0 0 0 .208-.208l2.706-7.317a.352.352 0 0 1 .659 0",
    fill: "#495867"
  }))))));
};
export default SvgNew;